"use strict";
exports.__esModule = true;
function getRandomInt(min, max, nonZero) {
    if (nonZero === void 0) { nonZero = false; }
    var a = Math.floor(Math.random() * (max - min + 1)) + min;
    if (nonZero) {
        if (Math.random() > .5) {
            return getRandomInt(min, max);
        }
        else {
            return -1 * getRandomInt(min, max);
        }
    }
    else {
        return a;
    }
}
exports["default"] = getRandomInt;
